import * as React from "react";
import { Box, Button, Chip } from "@mui/material";
import { useLocation, Link } from "react-router-dom";

export default function TopBar() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrolledStyles = {
    backgroundColor: "rgba(12, 15, 29, 0.5)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
  };

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        transition: "all 0.3s ease",
        width: "100%",
        px: { xs: 2, md: 4 },
        py: 2,
        borderBottom: "1px solid transparent",
        ...(isScrolled && scrolledStyles),
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", flex: 1 }}>
          <img
            src="/logo192.png"
            alt="LoafStack Logo"
            style={{ height: 64, marginRight: 22 }}
          />
          {/* <Typography
            variant="h6"
            sx={{
              fontWeight: 900,
              letterSpacing: 0.5,
              background: "transparent",
              backgroundColor: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              mr: 2,
            }}
          >
            LoafStack
          </Typography> */}
          {/* <Chip
            label="BETA LOAFING"
            size="small"
            sx={{
              bgcolor: "rgba(121, 209, 195, 0.2)",
              color: "#79d1c3",
              border: "1px solid rgba(121, 209, 195, 0.3)",
              fontSize: "0.7rem",
              fontWeight: 600,
              animation: "pulse 5s infinite",
              "@keyframes pulse": {
                "0%": { opacity: 1 },
                "50%": { opacity: 0.7 },
                "100%": { opacity: 1 },
              },
            }}
          /> */}
        </Box>

        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Button
            color="inherit"
            component={Link}
            to="/"
            sx={{
              position: "relative",
              backgroundColor:
                location.pathname === "/"
                  ? "rgba(255, 255, 255, 0.1)"
                  : "transparent",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              border:
                location.pathname === "/"
                  ? "2px solid rgba(255, 255, 255, 0.2)"
                  : "1px solid rgba(255, 255, 255, 0.1)",
              borderRadius: 2,
              px: 3,
              py: 1.5,
              color: "#ffffff",
              transition: "all 0.2s ease",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.15)",
                borderColor: "rgba(255, 255, 255, 0.3)",
                transform: "scale(1.02)",
              },
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: 0,
                left: "50%",
                width: location.pathname === "/" ? "100%" : "0%",
                height: "2px",
                bgcolor: "#79d1c3",
                transition: "all 0.3s ease",
                transform: "translateX(-50%)",
              },
              "&:hover::after": {
                width: "100%",
              },
            }}
          >
            Home
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
